import { Form, Radio, Flex } from "antd"
import { useTranslation } from "react-i18next"
import PropTypes from "prop-types"
import { SEASON_TYPES } from "../utils/constants"
import { InfoTooltip } from "ui/Tooltip/InfoTooltip"
import styles from "../../../../../ui/Radio/Radio.module.css"

export const SeasonTypeSelector = ({ onChange, value }) => {
  const { t } = useTranslation()

  return (
    <Form.Item>
      <Radio.Group onChange={onChange} defaultValue={SEASON_TYPES.ALL_YEAR} value={value} className="gap-3 flex flex-wrap">
        <Radio value={SEASON_TYPES.ALL_YEAR} className={styles?.radio}>{t("listings.tabs.scheduling.sections.seasons.all_year")}</Radio>
        <Radio value={SEASON_TYPES.SEASONAL} className={styles?.radio}>
          <Flex align="center" gap="small">
            {t("listings.tabs.scheduling.sections.seasons.seasonal")}
            <InfoTooltip title={t("listings.tabs.scheduling.sections.seasons.seasonal_tooltip")} />
          </Flex>
        </Radio>
      </Radio.Group>
    </Form.Item>
  )
}

SeasonTypeSelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOf(Object.values(SEASON_TYPES)).isRequired
}
